import React              from 'react';
import { useTranslation } from 'react-i18next';

export default function NoAnswersFoundComponent() {

    const { t } = useTranslation();

    return <div className={'text-align-center pt-4 font-size-16'}>{t('Analysis.NoAnswersFound')}</div>
}
